import AmericanCompanyContext from "components/company/v3/context/AmericanCompanyContext";
import { useContext } from "react";

export default function useAmericanIssuer() {
  const americanIssuer = useContext(AmericanCompanyContext);

  if (!americanIssuer) {
    throw new Error("No root issuer found. Make sure you're using this hook inside a issuer's context");
  }
  return americanIssuer;
}
